import {
  mapVenueCategoryType,
  mapVenueDetailsType,
  useFindVenueCategoriesSuspense,
  useFindVenueSuspense,
} from '@api';
import {
  EditActionIcon,
  TouringCard,
  TouringCardActions,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
} from '@common';
import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';
import { Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/venues/$id.general';
import { EditVenueForm, GeneralInformationTable } from './components';

export const VenueGeneralInformation: React.FC = () => {
  const { t } = useTranslation('venueDetailsGeneral');
  const { id } = Route.useParams();
  const [opened, { open: openModal, close: closeModal }] = useDisclosure(false);
  const { data: venue } = useFindVenueSuspense(id, {
    query: { select: (data) => mapVenueDetailsType(data.data) },
  });
  const { data: venueCategories } = useFindVenueCategoriesSuspense({
    query: {
      select: (data) => data.data.map(mapVenueCategoryType),
    },
  });
  const { hasPermission } = usePermissionContext();

  const userCanEditVenue = hasPermission({
    permission: 'VENUES_GENERAL',
    action: 'WRITE',
  });

  return (
    <>
      <TouringCard data-testid="venue-general-information-card">
        <TouringCardHeader>
          <TouringCardTitle>{t('GENERAL_INFORMATION.TITLE')}</TouringCardTitle>
          <TouringCardActions>
            {userCanEditVenue && <EditActionIcon onClick={openModal} />}
          </TouringCardActions>
        </TouringCardHeader>
        <TouringCardSection>
          <GeneralInformationTable venue={venue} />
        </TouringCardSection>
      </TouringCard>
      <Modal
        opened={opened}
        onClose={closeModal}
        size="lg"
        title={t('EDIT_VENUE_MODAL.TITLE')}
      >
        <EditVenueForm
          venue={venue}
          venueCategories={venueCategories}
          onClose={closeModal}
        />
      </Modal>
    </>
  );
};
